/**
 * @vuepress
 * ---
 * title: usersTransfomer
 * ---
 */

import Transformer from './transformer'
import { MinimalProvider } from '@/transformers/providers'

/**
 * @class usersTransfomer
 * Users info
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

const userFullName = ({ name, first_name: firstName, last_name: lastName, mothers_last_name: secondLastName, username }) =>
  `${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`
const userFullNameTreat = ({ treatment, name, first_name: firstName, last_name: lastName, mothers_last_name: secondLastName, username }) =>
  `${treatment || ''} ${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`

class usersTransfomer extends Transformer {
  static fetch({ provider, ...user }) {
    let providerInfo = null
    if (provider) {
      providerInfo = MinimalProvider.fetch(provider)
    }
    return {
      profileId: user.id,
      client: user.customer,
      emailAlternative: user.email,
      phone: user.phone,
      cellphone: user.cellphone,
      userId: user.id || user.pk,
      username: user.username,
      treatment: user.treatment,
      fullNameTreat: userFullNameTreat(user),
      fullName: userFullName(user),
      firstName: user.first_name,
      lastName: user.last_name,
      secondLastName: user.mothers_last_name,
      email: user.email,
      isActive: user.is_active,
      avatar: user.photo,
      groups: user.groups,
      groupName: user.groups && user.groups.length ? user.groups[0].name ? user.groups[0].name : user.groups[0] : '',
      password: user.password,
      provider: providerInfo
    }
  }
  /**
   * Update user data
   * @param user The user to be updated.
   * @returns {Object} The transformed user
   */
  static send(user) {
    return {
      'first_name': user.firstName,
      'last_name': user.lastName,
      'mothers_last_name': user.secondLastName,
      'email': user.email,
      'phone': user.phone,
      'cellphone': user.cellphone,
      'username': user.username,
      'groups': [user.group],
      'password': user.password
    }
  }
}
export default usersTransfomer
